import { EventDropdownActionsComponent } from "@circle-react/components/Events/CompassEventsSpace/EventDetailPage/EventDropdownActions/EventDropdownActionsComponent";
import type { Post } from "@circle-react/types/Post";
import { noop } from "lodash";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { EventDropdownActionsUIKitComponent } from "./EventDropdownActionsUIKitComponent";

interface EventDropdownActionsProps {
  displaySummarizeOption?: boolean;
  onChange: (data?: Post) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- callers pass inconsistent types ((Post) => void, (unknown) => void); called with event.id (number)
  onPostDestroy?: (...args: any[]) => void;
}

export const EventDropdownActions = ({
  onChange,
  onPostDestroy = noop,
  displaySummarizeOption = false,
}: EventDropdownActionsProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_dropdown_enabled");

  if (isCircleV4) {
    return (
      <EventDropdownActionsComponent
        onChange={onChange}
        onPostDestroy={onPostDestroy}
        displaySummarizeOption={displaySummarizeOption}
      />
    );
  }

  return (
    <EventDropdownActionsUIKitComponent
      onChange={onChange}
      onPostDestroy={onPostDestroy}
    />
  );
};
